<template>
	<div class="controls">

		<button v-if="showNew && !mobileUI" v-on:click="newClick" class="btn btn-success">
			<i class="fa fa-plus"></i> 
			New
		</button>

		<button v-if="showQuote && !mobileUI" v-on:click="newQuote" :disabled="isFreemiumUser" class="btn btn-success">
			<i v-if="isFreemiumUser" class="fa fa-lock"></i> 
			<i v-else class="fa fa-plus"></i> 
			New Quote
		</button>

		<slot></slot>

		<search-bar
			v-if="showSearch"
			placeholder="Search..."
			class="search-bar"
			v-on:submit="search"
			v-on:clearSearch="clearSearch">
		</search-bar>

		<nav-tabs 
			:tabs="tabs" 
			:active-index="activeNavIndex"
			:extra-action-menu-items-start="actionItems"
			:mobile-breakpoint="mobileBreakpoint"
			:addon-apps-location="isServices ? 'Services Module' : 'Projects Module'"
			:addon-apps-link="isServices ? '/service/apps' : '/project/apps'"
			v-on:buttonClick="buttonClick">		
		</nav-tabs>
	</div>
</template>
<script type="text/javascript">
import SearchBar from "../../components/SearchBar"	
import NavTabs from "../../layout_fragments/NavTabs"	

	export default {
		name: "ProjectsToolbarControls",
		components: {
			SearchBar,
			NavTabs
		},
		props:['showSearch',"showQuote","showNew","isServices","isSettings","activeNavIndex","actionItems","mobileBreakpoint"],
		computed: {
			mobileUI() {
				if (window.innerWidth > this.mobileBreakpoint)
					return false
				else
					return true
			},
			tabs() {
				let tabs = [
					/*{
						label: "Roles & Personnel",
						icon: "fa-group",
						path: "/personnel-roles",
						modulePermRequired: ["Settings","Projects","Services"]
					},*/
					{
						label: "Settings", //Project settings
						icon: "fa-cog",
						path: "/job-settings/all",
						modulePermRequired: ["Settings","Projects","Services"],
						freemiumTier: true
					}
				]

				if (this.isServices) {
					tabs.unshift({
						label: "Quote Templates",
						icon: "fa-copy",
						path: "/quote-templates",
						modulePermRequired: ["Services"]
					})

					tabs.unshift({
						label: "Service Tasks",
						icon: "fa-hammer",
						path: "/service-tasks",
						modulePermRequired: ["Services"]
					})

					tabs.unshift({
						label: "Service Contracts",
						icon: "fa-gavel",
						path: "/service-contracts",
						modulePermRequired: ["Contracts"]
					})

					tabs.splice(2,0,{
						label: "Reports",
						icon: "fa-chart-pie",
						path: "/services/reports",
						modulePermRequired: ["Services"]
					})

					tabs.unshift({
						label: "Services",
						icon: "fa-list",
						path: "/services",
						modulePermRequired: ["Services"],
						freemiumTier: true
					})

					
				}
				else if (this.isSettings) {
					tabs.unshift({
						label: "Projects",
						icon: "fa-cubes",
						path: "/projects/list",
						modulePermRequired: ["Projects"],
						freemiumTier: true
					})

					tabs.unshift({
						label: "Services",
						icon: "fa-wrench",
						path: "/services",
						modulePermRequired: ["Services"],
						freemiumTier: true
					})
				}
				else {
					tabs.unshift({
						label: "Bid Templates",
						icon: "fa-pencil-ruler",
						path: "/projects/bid-templates",
						modulePermRequired: ["Projects"]
					})
					tabs.unshift({
						label: "Reports",
						icon: "fa-chart-pie",
						path: "/projects/reports",
						modulePermRequired: ["Projects"]
					})
					tabs.unshift({
						label: "List",
						icon: "fa-list",
						path: "/projects/list",
						modulePermRequired: ["Projects"],
						freemiumTier: true
					})

				}

				return tabs
			}
		},
		methods: {
			buttonClick(button) {
				this.$emit("buttonClick",button)
			},
			search(terms) {
				this.$emit("searchSubmit",terms)
			},
			newClick() {
				this.$emit("newClick")
			},
			newQuote() {
				this.$emit("newClick",true)
			},
			clearSearch() {
				this.$emit("clearSearch")
			}
		}
	}
</script>

<style type="text/css" scoped>
	.search-bar {

	}
</style>